/**
 *英文语言包
 */
export const LANGUAGE = {
  guanbi: "Close",
  fanhui: "Return",
  rengong:"Artificial",
  rgkf: "Manual Customer Service",
  fqxdlthh: "Start a new chat session",
  tjwt: "Submit a question",
  tjcg: "Submit successfully",
  wtms: "Problem description",
  hfnr: "Reply to Content",
  tjhf: "Submit Reply",
  wjhf: "Player Reply",
  sbppxh: "Device brand model",
  sbxtbb: "Device system version",
  email: "Mailbox",
  wjjwt: "Unresolved issues",
  yjjwt: "Solved problem",
  qsrhfnr: "Please enter the reply content",
  ssgjc: "Please enter search keywords",
  faqcjwt: "Questions",
  qsrwtms: "Please enter a problem description",
  qmsnyddwt: "Please describe your problem!",
  xuantian: "Optional",
  loadling: "Loading ...",
  ltjldzljs: "The chat history ends here",
  error1: "Reply content cannot be empty!",
  error2: "The content of the reply does not exceed 150 words",
  error3: "Failed to get orderid!",
  error4: "Mailbox format is incorrect!",
  error5: "Failed to get the data, please try later. If you have problems with the attempt, please contact customer service!",
  error6: "There is currently no relevant data, please contact customer service if you have any questions!",
  error7: "Sorry if you can't solve your problem, please continue to send messages!",
  yhxy: "User Agreement",
  yscl: "Privacy policy",
  wjfk: "feedback",
  xuanze: "select",
  fwq:"server",
  yxzh:"Role Name",
  tishiyu: "Please be sure to leave your device information when consulting account login, freezing, black screen and other issues related to the inability to play the game normally. Providing complete information will help us solve your problem more quickly",
  ssjg: "search results",
  kfgzts: "Online customer service is available 09:00-00:00 (UTC+8). Please be patient. We will reply you as soon as possible!",
}



// WEBPACK FOOTER //
// ./src/language/en.js